// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-example {
    min-width: 500px;
}

.bolt-table-card {
    width: 100%;
}

.wrap-text {
    white-space: break-spaces;
    word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Table/examples/Table.Example.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".table-example {\r\n    min-width: 500px;\r\n}\r\n\r\n.bolt-table-card {\r\n    width: 100%;\r\n}\r\n\r\n.wrap-text {\r\n    white-space: break-spaces;\r\n    word-break: break-all;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
